import React from "react";

import ErrorIcon from "../../assets/icons/Error.svg";
import SuccessIcon from "../../assets/icons/Success.svg";

interface StatusIconProps {
  status?: "idle" | "loading" | "success" | "error";
}

const StatusIcon = ({ status }: StatusIconProps) => {
  return (
    <div className={`main-modal__icon-box text-${status}`}>
      {status === "loading" && (
        <div className="spinner-border m-auto" role="status" />
      )}
      {status === "success" && (
        <div className="m-auto success">
          <SuccessIcon width="4.7rem" height="3.4rem" />
        </div>
      )}
      {status === "error" && (
        <div className="m-auto error">
          <ErrorIcon width="1.1rem" height="4.6rem" />
        </div>
      )}
    </div>
  );
};

export default React.memo(StatusIcon);
